// extracted by mini-css-extract-plugin
var _1 = "InvestBtnComponentStyle-module__button___yTP_c";
var _2 = "InvestBtnComponentStyle-module__button-public___dkicp";
var _3 = "InvestBtnComponentStyle-module__button-public___dkicp";
export { _1 as "button", _2 as "button-public", _3 as "buttonPublic" }
